import { render, staticRenderFns } from "./TrainingVideoAdd.vue?vue&type=template&id=7fdd13a6&scoped=true&"
import script from "./TrainingVideoAdd.vue?vue&type=script&lang=js&"
export * from "./TrainingVideoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdd13a6",
  null
  
)

export default component.exports